module.exports = __webpack_public_path__ + "static/media/Slow_Control.9d91fc10.mp3";